import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

export default defineNuxtPlugin((nuxtApp) => {
  // Pinia에 Persist 플러그인 추가
  nuxtApp.$pinia.use(piniaPluginPersistedstate);
});